import React from 'react';
import Link from '../../Link';
import TopNavSearch from './TopNavSearch';

const TopBarMenu = (props) => {
  const { menuItems, menuVisible } = props;
  return (
    <ul className="top-bar-menu">
      {menuItems.map((item, i) => {
        const hasIcon = item.menuAcf?.menuIcon?.sourceUrl;
        const classes = item.cssClasses && item.cssClasses[0];

        return (
          <React.Fragment key={i}>
            <li
              className={`top-bar-menu__item ${
                hasIcon ? 'top-bar-menu__item--has-icon' : ''
              } ${classes ? classes : ''}`}
            >
              <Link to={item.url}>
                {hasIcon && (
                  <img
                    src={
                      item?.menuAcf?.menuIcon?.sourceUrl
                        ? item.menuAcf.menuIcon.sourceUrl
                        : ''
                    }
                    alt={item.label}
                  />
                )}
                {item.label}
              </Link>
            </li>
            {i === menuItems.length - 2 && (
              <TopNavSearch menuVisible={menuVisible} />
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
};

export default TopBarMenu;
